import * as type from "../../types/API/labelTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const addLabelReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_LABEL:
      return {
        ...state,
        loading: true,
      };
    case type.ADD_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.ADD_LABEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getLabelsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_LABELS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LABELS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.data,
      };
    case type.GET_LABELS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editLabelReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.EDIT_LABEL:
      return {
        ...state,
        loading: true,
      };
    case type.EDIT_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.EDIT_LABEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteLabelReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_LABEL:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.DELETE_LABEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const assignLabelsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ASSIGN_LABELS:
      return {
        ...state,
        loading: true,
      };
    case type.ASSIGN_LABELS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.ASSIGN_LABELS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const removeLabelReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.REMOVE_LABEL:
      return {
        ...state,
        loading: true,
      };
    case type.REMOVE_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.REMOVE_LABEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};